<script>
import baseMixin from '@/mixins/baseMixin'
import impersonateMixin from '@/mixins/impersonateMixin'
import { mapActions } from 'vuex'

export default {
  name: 'TheImpersonateBar',
  mixins: [baseMixin, impersonateMixin],
  computed: {
    compBarText() {
      return this.isMobileViewPort
        ? this.$t('impersonate.shortBarText')
        : this.$t('impersonate.barText')
    },
    compStopText() {
      return this.isMobileViewPort
        ? this.$t('impersonate.shortStopImpersonatingLinkText')
        : this.$t('impersonate.stopImpersonatingLinkText')
    },
  },
  methods: {
    ...mapActions({
      logOut: 'auth/logOut',
    }),
    signOut() {
      this.logOut({ redirect: true, nuke: true })
    },
  },
}
</script>

<template>
  <v-system-bar
    v-if="isImpersonating"
    app
    dark
    window
    color="blue"
    class="d-flex justify-center text-center align-center white--text caption"
  >
    <header class="mr-2">
      <v-icon small color="white">mdi-incognito</v-icon>

      {{ compBarText }}
      <span class="font-weight-medium">
        {{ firstName }}
      </span>
    </header>
    |
    <section class="ml-2">
      <a class="white--text text-decoration-underline" @click="signOut">
        {{ compStopText }}
      </a>
    </section>
  </v-system-bar>
</template>
